/* eslint-disable no-empty-pattern */
import React, { useRef } from "react";
import Button from "@material-ui/core/Button";
import "./App.css";
import { useStateValue } from "./StateProvider";
import { useHistory } from "react-router";
import "../style/Detail.css";
import isEmpty from "validator/lib/isEmpty";

const but = {
  fontSize: "20px",
  color: "white",
  backgroundColor: "#3391ff",
  borderRadius: "25px",
  padding: "12px",
};

const divStyle = {
  marginTop: "130px",
  text: "centre",
};

const forms = {
  textAlign: "center",
};
function Detail() {
  const [{}, dispatch] = useStateValue();
  const history = useHistory();

  const name = useRef(null);
  const place = useRef(null);
  const city = useRef(null);

  const submitted = (e) => {
    e.preventDefault();

    if (
      isEmpty(name.current.value) ||
      isEmpty(place.current.value) ||
      isEmpty(city.current.value)
    ) {
      alert("All fields are required.");
    } else {
      dispatch({
        type: "SET_NAME",
        name: name.current.value,
      });

      dispatch({
        type: "SET_PLACE",
        place: place.current.value,
      });

      dispatch({
        type: "SET_CITY",
        city: city.current.value,
      });

      history.push("/Form");
    }
  };

  return (
    <div className="bodyy">
      <div style={divStyle}>
        <div>
          <h1 className="heading">ENTER CANTEEN DETAILS</h1>

          <div style={forms}>
            <div className="form">
              <input
                type="text"
                className="form__input"
                autocomplete="off"
                placeholder=" "
                ref={name}
              />
              <label className="form__label">Canteen Name</label>
            </div>
            <div className="form">
              <input
                type="text"
                className="form__input"
                autocomplete="off"
                placeholder=" "
                ref={place}
              />
              <label className="form__label">State</label>
            </div>
            <div className="form">
              <input
                type="text"
                className="form__input"
                autocomplete="off"
                placeholder=" "
                ref={city}
              />
              <label className="form__label">City</label>
            </div>
          </div>
          <div className="container1">
            <div className="vertical-center">
              <Button
                style={but}
                type="submit"
                onClick={submitted}
                className="btn"
              >
                {" "}
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Detail;
